import { render, staticRenderFns } from "./VendorsView.vue?vue&type=template&id=9d582f40&"
import script from "./VendorsView.vue?vue&type=script&lang=js&"
export * from "./VendorsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports